import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { DocumentCategory } from 'src/app/libs/proto/commUnity_pb';

@Injectable({
  providedIn: 'root'
})
export class DocumentCategConversionService {

  constructor() { }

  ToStorage(req: DocumentCategory) {
    const w = new BinaryWriter();
    DocumentCategory.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (news: DocumentCategory, errorConvert: any) => void) {
    try {
      callback( DocumentCategory.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(news: DocumentCategory[]) {
    const rets = new Array<Uint8Array | number[]>();

    news.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (news: DocumentCategory[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<DocumentCategory>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = DocumentCategory.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }
}
